// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BranchBox{font-size:.875rem;max-width:600px}@media(min-width:768px){.BranchBox{padding-bottom:1rem}}svg.BranchBox__icon{color:#243a88;font-size:1.5em}.BranchBox__image{width:100%}.BranchBox__openingHoursWrapper{padding-top:.5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
